import api from './index';

export const newTask = async (companyId, payload) => {
  try {
    const { data } = await api.post('/task', { task: payload });

    return data;
  } catch (error) {
    throw error;
  }
};

export const getTask = async (taskId) => {
  try {
    const { data } = await api.get(`/task/${taskId}`);

    return data;
  } catch (error) {
    throw error;
  }
};

export const getTasksByCompanyAndUserId = async (company_id, user_id) => {
  try {
    const { data } = await api.get(`/partner/${company_id}/user/${user_id}/tasks`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (fields, userId) => {
  try {
    const { data } = await api.put(`/user/${userId}`, { user: fields });
    return data;
  } catch (error) {
    throw error;
  }
};
